function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 25.875,
  height: 25,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4328_8187)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.97621 20.8337C4.47991 20.8337 4.06555 20.6731 3.73313 20.3519C3.40071 20.0307 3.2345 19.6304 3.2345 19.1508V8.9748C3.2345 8.49529 3.40071 8.09494 3.73313 7.77376C4.06555 7.45258 4.47991 7.29199 4.97621 7.29199H9.70324V5.84954C9.70324 5.3702 9.86945 4.96994 10.2019 4.64876C10.5343 4.32758 10.9487 4.16699 11.445 4.16699H14.4303C14.9266 4.16699 15.3409 4.32758 15.6734 4.64876C16.0058 4.96994 16.172 5.3702 16.172 5.84954V7.29199H20.899C21.3953 7.29199 21.8097 7.45258 22.1421 7.77376C22.4745 8.09494 22.6407 8.49529 22.6407 8.9748V13.3477C22.4693 13.2422 22.2973 13.1503 22.1246 13.0722C21.9517 12.9941 21.7644 12.921 21.5626 12.8529V8.9748C21.5626 8.78783 21.5004 8.63418 21.3761 8.51387C21.2516 8.39373 21.0925 8.33366 20.899 8.33366H4.97621C4.78268 8.33366 4.62366 8.39373 4.49914 8.51387C4.37479 8.63418 4.31262 8.78783 4.31262 8.9748V19.1508C4.31262 19.3378 4.37479 19.4915 4.49914 19.6118C4.62366 19.7319 4.78268 19.792 4.97621 19.792H13.0185C13.0585 19.983 13.1014 20.162 13.147 20.329C13.1927 20.4958 13.2479 20.664 13.3128 20.8337H4.97621ZM10.7814 7.29199H15.0939V5.84954C15.0939 5.66274 15.0317 5.50918 14.9073 5.38887C14.7828 5.26873 14.6238 5.20866 14.4303 5.20866H11.445C11.2514 5.20866 11.0924 5.26873 10.9679 5.38887C10.8435 5.50918 10.7814 5.66274 10.7814 5.84954V7.29199ZM19.4064 22.917C18.2051 22.917 17.1861 22.5127 16.3493 21.704C15.5124 20.8955 15.0939 19.9109 15.0939 18.7503C15.0939 17.5897 15.5124 16.6052 16.3493 15.7967C17.1861 14.988 18.2051 14.5837 19.4064 14.5837C20.6076 14.5837 21.6266 14.988 22.4634 15.7967C23.3004 16.6052 23.7189 17.5897 23.7189 18.7503C23.7189 19.9109 23.3004 20.8955 22.4634 21.704C21.6266 22.5127 20.6076 22.917 19.4064 22.917ZM19.8209 18.5821V15.7456H18.9918V18.9186L21.1853 21.0381L21.7742 20.4691L19.8209 18.5821Z",
  fill: "#004E41"
}));

function SvgWorkHistory(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4328_8187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _ref2), _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHistory);
export default __webpack_public_path__ + "static/media/workHistory.b72acd123461bcb412189eed073e63a1.svg";
export { ForwardRef as ReactComponent };